import { createPatchEndpoint } from '@sonar-software/sonar-http';

export type PatchAdminChangePermissionRequest = {
	isLocked?: boolean;
	isReadOnly?: boolean;
	shardName: string;
	userId: number;
};

export const patchAdminChangePermission = createPatchEndpoint<PatchAdminChangePermissionRequest>(
	({ userId }) => `/api/v3/core/users/${userId}/admin-change-permission`
);
